<template>
  <a-row class="request-table-header">
    <a-col class="request-table-item__type-col">Тип проекта</a-col>
    <a-col class="request-table-item__number-col">Номер запроса</a-col>
    <a-col class="request-table-item__date-col">Дата запроса</a-col>
    <a-col class="request-table-item__status-col">Статус</a-col>
  </a-row>
</template>

<script setup></script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;
  @use '@/views/partner/requests/components/partner-request-table-item';
  $color-text-secondary-grey-216: #718096;

  .request-table-header {
    gap: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    border-bottom: 1px solid $color-bg-secondary-grey;

    color: $color-text-secondary-grey-216;
    font-variant-numeric: slashed-zero;
    font-family: Nunito Sans, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    padding: 40px 15px 10px 15px;
    margin-bottom: 10px;
  }
</style>
